/*eslint no-underscore-dangle: ["error", { "allow": ["_wapiq"] }]*/

export default function initializeUploader(accessToken, dropIn, projectId) {
  $.getScript('//fast.wistia.com/assets/external/api.js');
  global._wapiq = global._wapiq || [];
  const uploaderNode = document.getElementById(dropIn);

  return new Promise((resolve, reject) => {
    const handleUpload = (file, media) =>
      resolve({ file_name: file.name, wistia_id: media.id });

    const wistiaUploader = W => {
      new W.Uploader({ accessToken, dropIn, projectId }).bind(
        'uploadsuccess',
        handleUpload,
      );

      uploaderNode
        .querySelector('.wistia_upload_button_text')
        .classList.add('NewButton', 'NewButton--white');
    };

    global._wapiq.push(wistiaUploader);
  });
}
